// Global modal handler — guarded so it only runs once even if script loads multiple times
if (!window.__fileModalInit) {
  window.__fileModalInit = true;

  function fileModalToEmbedUrl(url) {
    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1';
    return url;
  }

  function fileModalIsImage(url) {
    return /\.(jpe?g|png|gif|webp|avif|svg|bmp)(\?|$)/i.test(url);
  }

  function fileModalClose() {
    const modal = document.getElementById('file-modal');
    if (!modal) return;
    modal.classList.remove('active');
    document.body.classList.remove('file-modal-open');
    const frame = modal.querySelector('.file-modal--frame');
    const image = modal.querySelector('.file-modal--image');
    if (frame) frame.src = '';
    if (image) image.src = '';
    modal.classList.remove('is-image');
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-modal-url]');
    if (!btn) return;
    const url = btn.getAttribute('data-modal-url');
    const isPdf = /\.pdf(\?|$)/i.test(url);
    const isMobile = window.innerWidth < 768;
    if (isPdf && isMobile) {
      window.open(url, '_blank');
      return;
    }
    const modal = document.getElementById('file-modal');
    if (!modal) return;
    const frame = modal.querySelector('.file-modal--frame');
    const image = modal.querySelector('.file-modal--image');
    if (fileModalIsImage(url)) {
      if (frame) frame.src = '';
      if (image) image.src = url;
      modal.classList.add('is-image');
    } else {
      if (image) image.src = '';
      if (frame) frame.src = fileModalToEmbedUrl(url);
      modal.classList.remove('is-image');
    }
    modal.classList.add('active');
    document.body.classList.add('file-modal-open');
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.file-modal--backdrop') || e.target.closest('.file-modal--close')) {
      fileModalClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fileModalClose();
  });
}

/**
 *  @class
 *  @function SidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class SidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button[data-id]');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.headings = this.drawer ? this.drawer.querySelectorAll('.side-panel--heading') : [];
      this.panels = this.drawer ? this.drawer.querySelectorAll('.side-panel-content--tab-panel') : [];
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.body.classList.add('open-cc');
          this.toggleActiveClass(i);
          if (this.drawer) {
            this.drawer.classList.add('active');
            this.drawer.removeAttribute('inert');
          }
        });
      });
    }
    toggleActiveClass(i) {
      this.panels.forEach((panel) => panel.classList.remove('tab-active'));
      this.headings.forEach((heading) => heading.classList.remove('tab-active'));
      if (this.panels[i]) this.panels[i].classList.add('tab-active');
      if (this.headings[i]) this.headings[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-links', SidePanelLinks);
}